import React from "react";
import { Button, Grid, Paper, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";

import useStyles from "./styles";

export default function AccessDenied() {
  const classes = useStyles();

  return (
    <Grid container className={classes.container} role="alert">
      <Paper classes={{ root: classes.paperRoot }}>
        <Typography variant="h1" color="primary" className={classes.textRow}>
          Access denied
        </Typography>
        <Typography variant="h5" color="primary" className={classes.textRow}>
          You do not have permission to view Appointment Settings.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to="/app/dashboard"
          size="large"
          className={classes.backButton}
        >
          Back to Dashboard
        </Button>
      </Paper>
    </Grid>
  );
}
